"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const CarbonTx = __importStar(require("../../../util/tx"));
const utils_1 = require("../utils");
const TxTypes = {
    CreateOracle: "oracle/CreateOracle",
    BindToken: "carbon/MsgBindToken",
    CreateToken: "carbon/MsgCreateToken",
    LinkToken: "carbon/MsgLinkToken",
    SyncToken: "carbon/MsgSyncToken",
    CreateMarket: "market/CreateMarket",
    CreateVaultType: "cdp/CreateVaultType",
    ChangeSwapFee: "liquiditypool/ChangeSwapFee",
    SetRewardsWeights: "liquiditypool/SetRewardsWeights",
    SetRewardCurve: "liquiditypool/SetRewardCurve",
    SetCommitmentCurve: "liquiditypool/SetCommitmentCurve",
    UpdatePool: "liquiditypool/UpdatePool",
    SetTradingFlag: "order/SetTradingFlag",
    SetMsgGasCost: "fee/SetMsgGasCost",
    SetMinGasPrice: "fee/SetMinGasPrice",
    RemoveMsgGasCost: "fee/RemoveMsgGasCost",
    RemoveMinGasPrice: "fee/RemoveMinGasPrice",
    CreateValidator: "cosmos-sdk/MsgCreateValidator",
    EditValidator: "cosmos-sdk/MsgEditValidator",
    AddRateStrategy: "cdp/AddRateStrategy",
    UpdateRateStrategy: "cdp/UpdateRateStrategy",
    RemoveRateStrategy: "cdp/RemoveRateStrategy",
    AddAsset: "cdp/AddAsset",
    UpdateAsset: "cdp/UpdateAsset",
    SetLiquidationFee: "cdp/SetLiquidationFee",
    SetInterestFee: "cdp/SetInterestFee",
    SetStablecoinInterestRate: "cdp/SetStablecoinInterestRate",
    SetCompleteLiquidationThreshold: "cdp/SetCompleteLiquidationThreshold",
    SetMinimumCloseFactor: "cdp/SetMinimumCloseFactor",
    SetSmallLiquidationSize: "cdp/SetSmallLiquidationSize",
};
const MsgCreateOracle = {
    aminoType: TxTypes.CreateOracle,
    valueMap: {
        createOracleParams: {
            minTurnoutPercentage: utils_1.ConvertEncType.Long,
            maxResultAge: utils_1.ConvertEncType.Long,
            resolution: utils_1.ConvertEncType.Long,
        },
    },
};
const MsgBindToken = {
    aminoType: TxTypes.BindToken,
    valueMap: {},
};
const MsgCreateToken = {
    aminoType: TxTypes.CreateToken,
    valueMap: {
        createTokenParams: {
            decimals: utils_1.ConvertEncType.Long,
            chainId: utils_1.ConvertEncType.Long,
            bridgeId: utils_1.ConvertEncType.Long,
        },
    },
};
const MsgLinkToken = {
    aminoType: TxTypes.LinkToken,
    valueMap: {},
};
const MsgSyncToken = {
    aminoType: TxTypes.SyncToken,
    valueMap: {},
};
const MsgCreateMarket = {
    aminoType: TxTypes.CreateMarket,
    valueMap: {
        expiryTime: utils_1.ConvertEncType.Date,
        currentBasePriceUsd: utils_1.ConvertEncType.Dec,
        currentQuotePriceUsd: utils_1.ConvertEncType.Dec,
    },
};
const MsgUpdatePool = {
    aminoType: TxTypes.ChangeSwapFee,
    valueMap: {
        updatePoolParams: {
            poolId: utils_1.ConvertEncType.Long,
            swapFee: utils_1.ConvertEncType.Dec,
            numQuotes: utils_1.ConvertEncType.Long,
        },
    },
};
const MsgSetRewardsWeights = {
    aminoType: TxTypes.SetRewardsWeights,
    valueMap: {
        setRewardsWeightsParams: {
            poolId: utils_1.ConvertEncType.Long,
        },
    },
};
const MsgSetRewardCurve = {
    aminoType: TxTypes.SetRewardCurve,
    valueMap: {
        setRewardCurveParams: {
            startTime: utils_1.ConvertEncType.Date,
            reductionIntervalSeconds: utils_1.ConvertEncType.Long,
        },
    },
};
const MsgSetCommitmentCurve = {
    aminoType: TxTypes.SetCommitmentCurve,
    valueMap: {
        setCommitmentCurveParams: {
            maxDuration: utils_1.ConvertEncType.Long,
        },
    },
};
const MsgSetTradingFlag = {
    aminoType: TxTypes.SetTradingFlag,
    valueMap: {},
};
const MsgSetGasCost = {
    aminoType: TxTypes.SetMsgGasCost,
    valueMap: {},
};
const MsgSetMinGasPrice = {
    aminoType: TxTypes.SetMinGasPrice,
    valueMap: {},
};
const MsgRemoveGasCost = {
    aminoType: TxTypes.RemoveMsgGasCost,
    valueMap: {},
};
const MsgRemoveMinGasPrice = {
    aminoType: TxTypes.RemoveMinGasPrice,
    valueMap: {},
};
const MsgCreateValidator = {
    aminoType: TxTypes.CreateValidator,
    valueMap: {
        commission: {
            rate: utils_1.ConvertEncType.Dec,
            maxRate: utils_1.ConvertEncType.Dec,
            maxChangeRate: utils_1.ConvertEncType.Dec,
        },
    },
};
const MsgEditValidator = {
    aminoType: TxTypes.EditValidator,
    valueMap: {
        commissionRate: utils_1.ConvertEncType.Dec,
    },
};
const MsgAddRateStrategy = {
    aminoType: TxTypes.AddRateStrategy,
    valueMap: {},
};
const MsgUpdateRateStrategy = {
    aminoType: TxTypes.UpdateRateStrategy,
    valueMap: {},
};
const MsgRemoveRateStrategy = {
    aminoType: TxTypes.RemoveRateStrategy,
    valueMap: {},
};
const MsgAddAsset = {
    aminoType: TxTypes.AddAsset,
    valueMap: {},
};
const MsgUpdateAsset = {
    aminoType: TxTypes.UpdateAsset,
    valueMap: {},
};
const MsgSetLiquidationFee = {
    aminoType: TxTypes.SetLiquidationFee,
    valueMap: {},
};
const MsgSetInterestFee = {
    aminoType: TxTypes.SetInterestFee,
    valueMap: {},
};
const MsgSetCompleteLiquidationThreshold = {
    aminoType: TxTypes.SetCompleteLiquidationThreshold,
    valueMap: {
        completeLiquidationThreshold: utils_1.ConvertEncType.Dec,
    },
};
const MsgSetMinimumCloseFactor = {
    aminoType: TxTypes.SetMinimumCloseFactor,
    valueMap: {
        minimumCloseFactor: utils_1.ConvertEncType.Dec,
    },
};
const MsgSetSmallLiquidationSize = {
    aminoType: TxTypes.SetSmallLiquidationSize,
    valueMap: {
        smallLiquidationSize: utils_1.ConvertEncType.Dec,
    },
};
const AdminAmino = {
    [CarbonTx.Types.MsgCreateOracle]: (0, utils_1.generateAminoType)(MsgCreateOracle),
    [CarbonTx.Types.MsgBindToken]: (0, utils_1.generateAminoType)(MsgBindToken),
    [CarbonTx.Types.MsgCreateToken]: (0, utils_1.generateAminoType)(MsgCreateToken),
    [CarbonTx.Types.MsgLinkToken]: (0, utils_1.generateAminoType)(MsgLinkToken),
    [CarbonTx.Types.MsgSyncToken]: (0, utils_1.generateAminoType)(MsgSyncToken),
    [CarbonTx.Types.MsgCreateMarket]: (0, utils_1.generateAminoType)(MsgCreateMarket),
    [CarbonTx.Types.MsgUpdatePool]: (0, utils_1.generateAminoType)(MsgUpdatePool),
    [CarbonTx.Types.MsgSetRewardsWeights]: (0, utils_1.generateAminoType)(MsgSetRewardsWeights),
    [CarbonTx.Types.MsgSetRewardCurve]: (0, utils_1.generateAminoType)(MsgSetRewardCurve),
    [CarbonTx.Types.MsgSetCommitmentCurve]: (0, utils_1.generateAminoType)(MsgSetCommitmentCurve),
    [CarbonTx.Types.MsgSetTradingFlag]: (0, utils_1.generateAminoType)(MsgSetTradingFlag),
    [CarbonTx.Types.MsgSetGasCost]: (0, utils_1.generateAminoType)(MsgSetGasCost),
    [CarbonTx.Types.MsgSetMinGasPrice]: (0, utils_1.generateAminoType)(MsgSetMinGasPrice),
    [CarbonTx.Types.MsgRemoveGasCost]: (0, utils_1.generateAminoType)(MsgRemoveGasCost),
    [CarbonTx.Types.MsgRemoveMinGasPrice]: (0, utils_1.generateAminoType)(MsgRemoveMinGasPrice),
    [CarbonTx.Types.MsgCreateValidator]: (0, utils_1.generateAminoType)(MsgCreateValidator),
    [CarbonTx.Types.MsgEditValidator]: (0, utils_1.generateAminoType)(MsgEditValidator),
    [CarbonTx.Types.MsgAddRateStrategy]: (0, utils_1.generateAminoType)(MsgAddRateStrategy),
    [CarbonTx.Types.MsgUpdateRateStrategy]: (0, utils_1.generateAminoType)(MsgUpdateRateStrategy),
    [CarbonTx.Types.MsgRemoveRateStrategy]: (0, utils_1.generateAminoType)(MsgRemoveRateStrategy),
    [CarbonTx.Types.MsgAddAsset]: (0, utils_1.generateAminoType)(MsgAddAsset),
    [CarbonTx.Types.MsgUpdateAsset]: (0, utils_1.generateAminoType)(MsgUpdateAsset),
    [CarbonTx.Types.MsgSetLiquidationFee]: (0, utils_1.generateAminoType)(MsgSetLiquidationFee),
    [CarbonTx.Types.MsgSetInterestFee]: (0, utils_1.generateAminoType)(MsgSetInterestFee),
    [CarbonTx.Types.MsgSetCompleteLiquidationThreshold]: (0, utils_1.generateAminoType)(MsgSetCompleteLiquidationThreshold),
    [CarbonTx.Types.MsgSetMinimumCloseFactor]: (0, utils_1.generateAminoType)(MsgSetMinimumCloseFactor),
    [CarbonTx.Types.MsgSetSmallLiquidationSize]: (0, utils_1.generateAminoType)(MsgSetSmallLiquidationSize),
};
exports.default = AdminAmino;
